import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import useApi from "../../helpers/apiHelper/requestHelper";
import { showNotificationToast, toastify } from "../../helpers/toast/toastify";
import { setRefetchSpecificUser } from "../../redux/multicommunity/multicommunity";
import { useDispatch, useSelector } from "react-redux";
import crossBlack from "../../assets/images/onboardingImages/crossBlack.svg";
import logo_black from "../../assets/images/onboardingImages/logo_black.svg";
import { Modal } from "react-bootstrap";
import BubbleSvgButton from "../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const SubscriptionResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.user);
  const api = useApi();

  const sessionId = searchParams.get("session_id");

  const sendUserDataOnBlockChain = async () => {
    try {
    const response=await api("post", "blocakChain/sendSpecificUserStatsOnBlockChain");
      console.log("Successfully sent to blockchain API",response);
    } catch (error) {
      console.log("Error sending to blockchain:", error);
    }
  };

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        setLoading(true);
        const response = await api(
          "get",
          `users/verifyTradeCheckoutSubscription?session_id=${sessionId}`
        );

        if (response?.status && response.data.paid) {
          await sendUserDataOnBlockChain();
          // showNotificationToast("Verifying your trades now!", "Your trading is now being verified.You'll get a link each time it's updated on-chain.\n\nUpgrade your subscription for more frequent updates.");
          // toastify("You’re subscribed and performance will be verified.");
          dispatch(setRefetchSpecificUser(true));
          setLoading(false);
        } else {
          setLoading(false);
          toastify("Payment not completed or failed.");
        }
      } catch (error) {
        setLoading(false);
        console.error("Payment check failed:", error);
        toastify("Something went wrong");
      }
    };

    if (sessionId) checkPaymentStatus();
  }, [sessionId]);

  const handleClose = () => {
    navigate("/leader/dashboard");
  };

  // Get subscription details
  const subscription = user?.verifiedmyTrade?.subscription;

  // Format dates
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Get frequency description based on plan type
  const getFrequencyDescription = () => {
    if (!subscription) return "";

    // Extract frequency from planType (e.g., "monthly-blockchain-daily" -> "daily")
    const planTypeParts = subscription.planType?.split("-");
    const frequency = planTypeParts?.[planTypeParts.length - 1] || "monthly";

    return frequency === "daily"
      ? "We send your stats to the blockchain daily"
      : "We send your stats to the blockchain monthly";
  };

  // Get billing description
  const getBillingDescription = () => {
    if (!subscription) return "";

    const planType = subscription.planType || subscription.frequency;

    if (planType?.includes("yearly") || planType === "yearly") {
      return "You purchased a yearly plan, so we deduct the amount every year";
    } else {
      return "You purchased a monthly plan, so we deduct the amount every month";
    }
  };

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal"
        show={true}
      >
        <Modal.Body
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: "130px",
          }}
        >
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="" src={crossBlack} />
          </button>

          <div>
            {loading && <p>Your stats are being sent to the blockchain...</p>}
            {!loading && (
              <div
                style={{
                  marginBottom: "50px",
                  textAlign: "center",
                }}
              >
                <h3
                  style={{
                    fontFamily: "Graphik Medium",
                    fontSize: "20px",
                    marginBottom: "20px",
                    color: "#333",
                  }}
                >
                  Subscription Activated Successfully!
                </h3>

                {subscription && (
                  <div
                    style={{
                      padding: "20px",
                      borderRadius: "8px",
                      marginBottom: "20px",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ marginBottom: "15px" }}>
                      <strong
                        style={{
                          fontFamily: "Graphik Medium",
                          fontSize: "14px",
                        }}
                      >
                        Subscription Period:
                      </strong>
                      <p
                        style={{
                          fontFamily: "Graphik Regular",
                          fontSize: "14px",
                          margin: "5px 0",
                        }}
                      >
                        From: {formatDate(subscription.currentPeriodStart)}
                      </p>
                      <p
                        style={{
                          fontFamily: "Graphik Regular",
                          fontSize: "14px",
                          margin: "5px 0",
                        }}
                      >
                        To: {formatDate(subscription.currentPeriodEnd)}
                      </p>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                      <strong
                        style={{
                          fontFamily: "Graphik Medium",
                          fontSize: "14px",
                        }}
                      >
                        Blockchain Updates:
                      </strong>
                      <p
                        style={{
                          fontFamily: "Graphik Regular",
                          fontSize: "14px",
                          margin: "5px 0",
                        }}
                      >
                        {getFrequencyDescription()}
                      </p>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                      <strong
                        style={{
                          fontFamily: "Graphik Medium",
                          fontSize: "14px",
                        }}
                      >
                        Billing Information:
                      </strong>
                      <p
                        style={{
                          fontFamily: "Graphik Regular",
                          fontSize: "14px",
                          margin: "5px 0",
                        }}
                      >
                        {getBillingDescription()}
                      </p>
                    </div>

                    <div>
                      <strong
                        style={{
                          fontFamily: "Graphik Medium",
                          fontSize: "14px",
                        }}
                      >
                        Status:
                      </strong>
                      <span
                        style={{
                          fontFamily: "Graphik Regular",
                          fontSize: "14px",
                          color:
                            subscription.status === "active"
                              ? "#28a745"
                              : "#dc3545",
                          marginLeft: "5px",
                          textTransform: "capitalize",
                        }}
                      >
                        {subscription.status}
                      </span>
                    </div>
                  </div>
                )}

                {user?.blockChainLink && (
                  <div style={{ marginBottom: "15px" }}>
                    <span
                      style={{
                        fontFamily: "Graphik Medium",
                        fontSize: "16px",
                        display: "block",
                        marginBottom: "5px",
                      }}
                    >
                      Blockchain Verification Link:
                    </span>
                    <a
                      style={{
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        fontFamily: "Graphik Regular",
                        fontSize: "14px",
                        color: "#007bff",
                      }}
                      href={user.blockChainLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {user.blockChainLink}
                    </a>
                  </div>
                )}

                {user?.blockChainId && (
                  <div>
                    <span
                      style={{
                        fontFamily: "Graphik Medium",
                        fontSize: "16px",
                        display: "block",
                        marginBottom: "5px",
                      }}
                    >
                      Blockchain Public ID:
                    </span>
                    <p
                      style={{
                        fontFamily: "Graphik Regular",
                        fontSize: "14px",
                        margin: "0",
                      }}
                    >
                      {user.blockChainId}
                    </p>
                  </div>
                )}
              </div>
            )}

            <BubbleSvgButton
              onClick={handleClose}
              text={"Next"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "250px",
                height: "auto",
              }}
            />
          </div>

          <div className="paginationDots">
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot active"></button>
          </div>
          <div className="copyrightBox">
            <p>
              Powered by
              <span className="spanMain">
                <img alt="" src={logo_black} />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubscriptionResult;
